import store from '@/store'
import router from '@/router'
import axios from './Axios'
import $Dialog from './Dialog'
import i18n from '@/i18n'

const model = {
  InvestContract(json,callback){
    const getData = ({data}) => {
      callback&&callback(data);
    }
    axios.post('Project/hetong',json).then(getData).catch(()=>{})
  },
  InvestOrderList(json,callback){
    const getData = ({data}) => {
      callback&&callback(data);
    }
    axios.post('Project/Orderlist',json).then(getData).catch(()=>{})
  },
  InvestRecordList(json,callback){
    const getData = ({data}) => {
      callback&&callback(data);
    }
    axios.post('Project/orderRecordList',json).then(getData).catch(()=>{})
  },
  GetProjectList(callback){
    const getData = ({data}) => {
      data = data.filter(item=>item.projectlist||item.is_v==1)
      const all = data.flatMap(item => item.projectlist).filter(item=>item);
      data.unshift({
        group_id: 0,
        group_info: '',
        group_name: '',
        projectlist: all
      })
      callback&&callback(data);
    }
    axios.post('Project/getProjectlist','',{noLogin: true}).then(getData).catch(()=>{})
  },
  GetProjectInfo(json,callback){
    const getData = ({data}) => {
      callback&&callback(data);
    }
    axios.post('Project/getProjectinfo',json).then(getData).catch(()=>{})
  },
  InvestOrder(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getData = ({data}) => {
      if(data.code==1){
        this.GetUserInfo()
      }
      callback&&callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('Project/createOrder',json).then(getData).catch(()=>{})
  },
  CouponTransfer(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({data}) => {
      callback&&callback(data)
      $Dialog.Toast(data.code_dec)
    }
    axios.post('user/couponTransfer',json).then(getResponse)
  },
  GetCouponList(json,callback){
    const getResponse = ({data}) => {
      callback&&callback(json,data)
    }
    axios.post('user/couponList',json).then(getResponse)
  },
  GetProfitRecord(callback){
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('Report/getReportRecord').then(getResponse)
  },
  GetActivityList(json,callback){
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('Common/activityList',json).then(getResponse)
  },
  GetPrizeRecord(callback){
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('user/lotteryList').then(getResponse)
  },
  SubmitLottery(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({data}) => {
      callback&&callback(data)
      if(data.code==1){
        this.GetUserInfo()
      }
      $Dialog.Toast(data.code_dec)
    }
    axios.post('user/lotteryDo',json).then(getResponse)
  },
  GetFinanceOrderDetail(json,callback){
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('financial/orderDetail',json).then(getResponse)
  },
  OutFinanceOrder(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({data}) => {
      callback&&callback(data)
      if(data.code==1){
        this.GetUserInfo()
      }
      $Dialog.Toast(data.code_dec)
    }
    axios.post('financial/userOutFinancial',json).then(getResponse)
  },
  GetFinanceOrder(json,callback){
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('financial/orderList',json).then(getResponse)
  },
  SubmitFinanceOrder(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({data}) => {
      callback&&callback(data)
      if(data.code==1){
        this.GetUserInfo()
      }
      $Dialog.Toast(data.code_dec)
    }
    axios.post('financial/createOrder',json).then(getResponse)
  },
  GetFinanceDetail(json,callback){
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('financial/detail',json).then(getResponse)
  },
  GetFinanceList(callback){
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('financial/list').then(getResponse)
  },
  GetChatLotteryAll: function(lottery,callback) {
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('Play/GetLotteryAll', {lottery: lottery,is_chat:1}).then(getResponse)
  },
  GetBet(lottery,callback){
    const getResponse = ({data}) => {
      data.rebate_mode_max = (parseFloat(data.rebate_mode_min) + parseFloat(store.state.UserInfo.flevel_fd) * 20).toFixed(2);
      callback&&callback(data)
    }
    axios.post('Play/Bet',{lottery: lottery}).then(getResponse)
  },
  GetNoLotteryInfo(json,callback){
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('Play/GetNoLotteryInfo', json).then(getResponse)
  },
  GetNoList(json,callback){
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('Play/getNoList', json).then(getResponse)
  },
  Retreat: function(json, callback) {
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('Play/Retreat', json).then(getResponse)
  },
  GetNowWining: function(callback) {
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('Report/getnowwinnIng', json).then(getResponse)
  },
  GetBetRecord(json,callback){
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('Report/GetBetRecord', json).then(getResponse)
  },
  GetRecordList: function(json,callback) {
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('Record/getRecordList', json).then(getResponse)
  },
  SendRecord: function(json,callback) {
    const getResponse = ({data}) => {
      callback&&callback(data)
    }
    axios.post('Record/sendRecord', json).then(getResponse)
  },
  GetMailCode(json,callback) {
    const getResponse = ({data}) => {
      callback&&callback(data);
      if(data.code!=1){
        $Dialog.Toast(data.code_dec);
      }
    }
    axios.post('sms/sendMailCode',json,{noLogin: true}).then(getResponse)
  },
  SubmitAllVideo(json,callback) {
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({ data }) => {
      callback && callback(data);
      if(data.code==1){
        this.GetStatisticsInfo()
      }
      $Dialog.Toast(data.code_dec);
    }
    axios.post('Task/allOrderSubmit',json).then(getResponse);
  },
  GetOnline(callback,json) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('Common/getonline',json).then(getResponse);
  },
  GetCommunityList(json,callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('user/communitylist',json).then(getResponse);
  },
  GetShareInfo(json, callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('task/shareInfo', json).then(getResponse);
  },
  GetShareList(json,callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('task/shareTaskList',json).then(getResponse);
  },
  SubmitShare(json, callback) {
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({ data }) => {
      callback && callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('task/shareOrderSubmit', json).then(getResponse);
  },
  JoinPartner(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({data}) => {
      if(data.code==1){
        this.GetStatisticsInfo();
        this.GetUserInfo();
      }
      callback&&callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('user/joincrowdfunding',json).then(getResponse);
  },
  GetJoinPartner(json, callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('user/crowdfundingList', json).then(getResponse);
  },
  GetMyPartner(json, callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('user/userCrowdfundingList', json).then(getResponse);
  },
  CreatePartner(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({data}) => {
      if(data.code==1){
        this.GetStatisticsInfo();
        this.GetUserInfo();
      }
      callback&&callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('user/createCrowdfunding',json).then(getResponse);
  },
  GetPartnerList(json, callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('task/crowdfundingTaskList', json).then(getResponse);
  },
  SubmitPartner(json, callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
      if(data.code==1){
        this.GetStatisticsInfo()
      }
    }
    axios.post('task/crowdfundingOrderSubmit', json).then(getResponse);
  },
  ReceivePartner(json, callback) {
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({ data }) => {
      callback && callback(data);
      if(data.code!=1){
        $Dialog.Toast(data.code_dec);
      }else{
        $Dialog.Clear()
      }
    }
    axios.post('task/crowdfundingReceiveTask', json).then(getResponse);
  },
  GetPushMsg(callback){
    const getResponse = ({data}) => {
      callback&&callback(data);
    }
    axios.post('Record/recordList').then(getResponse);
  },
  RetrievePassword(json,callback){
    const getResponse = ({data}) => {
      if(data.code==1){
        router.replace('/login');
      }
      callback&&callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('user/retrievePassword',json,{noLogin: true}).then(getResponse);
  },
  ReceiveReward(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({data}) => {
      if(data.code==1){
        this.GetUserInfo();
      }
      callback&&callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('user/receiveReward',json).then(getResponse);
  },
  GetRewardlist(callback){
    const getResponse = ({data}) => {
      callback&&callback(data);
    }
    axios.post('user/rewardlist').then(getResponse);
  },
  GetBackData(callback){
    const getResponse = ({data}) => {
      store.dispatch('UpdateInitData', data.info||'')
      callback&&callback(data.info);
    }
    axios.post('Common/BackData','',{noLogin: true}).then(getResponse);
  },
  Login(json,callback){
    const getResponse = ({data}) => {
      if(data.code==1){
        this.GetStatisticsInfo()
        this.GetUserInfo()
        localStorage['MiName'] = data.info.username;
        localStorage['Token'] = data.info.token;
        localStorage['UserId'] = data.info.userid;
        if(store.state.InitData.Login_agreement){
          $Dialog.Protocol(store.state.InitData.Login_agreement,()=>{
            if(localStorage['FromPage']){
              router.replace(localStorage['FromPage']);
              localStorage.removeItem('FromPage');
            }else{
              router.replace('/');
            }
          },()=>{
            this.Logout()
          })
        }else{
          if(localStorage['FromPage']){
            router.replace(localStorage['FromPage']);
            localStorage.removeItem('FromPage');
          }else{
            router.replace('/');
          }
        }
      }
      callback&&callback(data);
      if(data.code==11){
        localStorage['MiName'] = data.info.username;
        localStorage['Token'] = data.info.token;
        localStorage['UserId'] = data.info.userid;
        store.dispatch('UpdateUserInfo', data.info);
        $Dialog.Alert(data.code_dec,()=>{
          localStorage.removeItem('FromPage');
          router.replace('/vip');
        });
      }else if(data.code==8){

      }else{
        $Dialog.Toast(data.code_dec);
      }
    }
    axios.post('User/Login',json,{noLogin: true}).then(getResponse);
  },
  Logout(callback){
    const getResponse = ({data}) => {
      if(data.code==1){
        localStorage.removeItem('Token');
        localStorage.removeItem('UserInfo');
        localStorage.removeItem('BankCardList');
        store.dispatch('UpdateUserInfo', '');
        store.dispatch('UpdateBankCardList', []);
        this.GetBackData();
        router.replace('/');
      }
      $Dialog.Toast(data.code_dec);
    }
    axios.post('User/Logout').then(getResponse);
  },
  UserRegister(json,callback){
    $Dialog.Loading(i18n.t('dialog[5]'));
    const getResponse = ({data}) => {
      if(data.code==1){
        model.Login({username: json.username, password: json.password})
      }
      callback&&callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('user/Register',json,{noLogin: true}).then(getResponse);
  },
  VerifyCode(json,callback) {
    const getResponse = ({data}) => {
      callback&&callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('sms/verifyCode',json).then(getResponse);
  },
  SmsCode(callback) {
    const getResponse = ({data}) => {
      callback&&callback(data);
    }
    axios.post('sms/smsCode','',{noLogin: true}).then(getResponse);
  },
  GetSMSCode(json,callback) {
    const getResponse = ({data}) => {
      callback&&callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('sms/sendSMSCode',json,{noLogin: true}).then(getResponse);
  },
  GetUserInfo(callback){
    const getResponse = ({data}) => {
      if(data.code==1){
        store.dispatch('UpdateUserInfo', data.info);
      }
      callback&&callback(data);
    }
    axios.post('user/getUserInfo').then(getResponse);
  },
  SetUserInfo(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({data}) => {
      if(data.code==1){
        this.GetUserInfo();
      }
      callback&&callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('user/setuserinfo',json).then(getResponse);
  },
  CreateOrder(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({data}) => {
      if(data.code==1){
        router.push('/user/invest');
        this.GetUserInfo();
      }
      callback&&callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('Order/createOrder',json).then(getResponse);
  },
  OrderList(callback){
    const getResponse = ({data}) => {
      callback&&callback(data);
    }
    axios.post('Order/Orderlist').then(getResponse);
  },
  OrderRecordList(id,callback){
    const getResponse = ({data}) => {
      callback&&callback(data);
    }
    axios.post('Order/orderRecordList',{orderid: id}).then(getResponse);
  },
  FundDetails(json, callback){
    const getResponse = ({data}) => {
      callback&&callback(data);
    }
    axios.post('Transaction/FundDetails',json).then(getResponse);
  },
  GetDrawRecord(json, callback){
    const getResponse = ({data}) => {
      callback&&callback(data);
    }
    axios.post('Transaction/getDrawRecord',json).then(getResponse);
  },
  Draw(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({data}) => {
      if(data.code==1){
        this.GetUserInfo();
      }
      callback&&callback(data);
    }
    axios.post('Transaction/draw',json).then(getResponse);
  },
  Transfer(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({data}) => {
      if(data.code==1){
        this.GetUserInfo();
      }
      callback&&callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('Transaction/Transfer',json).then(getResponse);
  },
  AddBankCard(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({data}) => {
      if(data.code==1){
        this.GetBankCardList()
      }
      callback&&callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('Account/AddBankCard',json).then(getResponse);
  },
  GetBankCardList(callback){
    const getResponse = ({data}) => {
      store.dispatch('UpdateBankCardList', data.data||[]);
      callback&&callback(data);
    }
    axios.post('Account/getBankCardList').then(getResponse);
  },
  GetRechargeRecord(json,callback){
    const getResponse = ({data}) => {
      callback&&callback(data);
    }
    axios.post('Transaction/getRechargeRecord',json).then(getResponse);
  },
  GetRechargeType(callback){
    const getResponse = ({data}) => {
      callback&&callback(data);
    }
    axios.post('Transaction/getRechargetype',{type:'app'}).then(getResponse);
  },
  RechargeOrder(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({data}) => {
      if(data.code==1){
        router.push('/user/wallet')
      }
      callback&&callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('Recharge/newRechargeOrder',json).then(getResponse);
  },
  GetRechargeInfo(orderId,callback){
    const getResponse = ({data}) => {
      callback&&callback(data);
    }
    axios.post('Recharge/getRechargeInfo',{orderNumber: orderId}).then(getResponse);
  },
  SetOrderInfo(json,callback){
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({data}) => {
      callback&&callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('Recharge/setOrderInfo',json).then(getResponse);
  },
  UploadImg(json, callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('User/UploadImg', json, { fromData: true, portURL: store.state.InitData.setting.up_url }).then(getResponse);
  },
  BuyVip(json, callback) {
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({ data }) => {
      callback && callback(data);
      if(data.code==1){
        this.GetStatisticsInfo()
        this.GetUserInfo()
      }
      $Dialog.Toast(data.code_dec);
    }
    axios.post('User/userBuyVip', json).then(getResponse);
  },
  PostTask(json, callback) {
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({ data }) => {
      callback && callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('task/publishTask', json).then(getResponse);
  },
  GetTaskList(json, callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('task/getTaskList', json).then(getResponse);
  },
  ReceiveTask(id, callback) {
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({ data }) => {
      callback && callback(data);
      if(data.code!=1){
        if(data.code==11||data.code==12){
          $Dialog.Clear()
          $Dialog.Alert(data.code_dec,()=>{
            router.push('/vip')
          })
        }else{
          $Dialog.Toast(data.code_dec)
        }
      }else{
        $Dialog.Clear()
      }
    }
    axios.post('task/receiveTask', {id: id}).then(getResponse);
  },
  GetTaskinfo(id, callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('task/getTaskinfo', {id: id}).then(getResponse);
  },
  GetTaskRecord(json, callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('task/taskOrderlist', json).then(getResponse);
  },
  SubmitTask(json, callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
      if(data.code==1){
        this.GetStatisticsInfo()
      }
    }
    axios.post('task/taskOrderSubmit', json).then(getResponse);
  },
  CancelTask(id, callback) {
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({ data }) => {
      callback && callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('task/revokeTask', {id: id}).then(getResponse);
  },
  TaskOrderInfo(id, callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('task/taskorderinfo', {order_id: id}).then(getResponse);
  },
  AuditTask(json, callback) {
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({ data }) => {
      callback && callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('task/taskOrderTrial', json).then(getResponse);
  },
  DailyReport(callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('User/dailyReport').then(getResponse);
  },
  CreditList(callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('user/getUserCreditList').then(getResponse);
  },
  TeamReport(json,callback) {
    $Dialog.Loading(i18n.t('dialog[6]'));
    const getResponse = ({ data }) => {
      $Dialog.Clear();
      callback && callback(data);
    }
    axios.post('user/teamReport',json).then(getResponse);
  },
  GetStatisticsInfo(callback) {
    const getResponse = ({ data }) => {
      if(data.code==1){
        store.dispatch('UpdateStatisticalData', data.info);
      }
      callback && callback(data);
    }
    axios.post('user/getStatisticsInfo').then(getResponse);
  },
  GetPayBank(json,callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('Account/GetPayBankCode',json).then(getResponse);
  },
  Robot(num,callback) {
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({ data }) => {
      $Dialog.Clear();
      if(data.code==1){
        this.GetStatisticsInfo()
      }
      if(data.code!=2){
        $Dialog.Toast(data.code_dec);
      }
      callback && callback(data);
    }
    axios.post('user/userUseRobot',{num: num}).then(getResponse);
  },
  UserFinancialReport(callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('user/userFinancialReport').then(getResponse);
  },
  UserFinancialList(json,callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('user/userFinancialList',json).then(getResponse);
  },
  UserBuyFinancial(json,callback) {
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({ data }) => {
      callback && callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('user/userBuyFinancial',json).then(getResponse);
  },
  UserOutFinancial(id,callback) {
    $Dialog.Loading(i18n.t('dialog[2]'));
    const getResponse = ({ data }) => {
      callback && callback(data);
      $Dialog.Toast(data.code_dec);
    }
    axios.post('user/userOutFinancial',{id:id}).then(getResponse);
  },
  FinancialOrderInfo(id,callback) {
    const getResponse = ({ data }) => {
      callback && callback(data);
    }
    axios.post('user/financialorderinfo',{id:id}).then(getResponse);
  },
}

export default model
